<template>
  <div :class="['single-page-content', { 'single-page-content--blue': blueBackground }]">
    <tm-scrollbar>
      <slot />
    </tm-scrollbar>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@/composition/vue/compositionApi'
import TmScrollbar from '@/components/shared/TmScrollbar.vue'

export default defineComponent({
  components: {
    TmScrollbar,
  },
  props: {
    blueBackground: Boolean,
  },
})
</script>

<style lang="scss" scoped>
.single-page-content {
  position: relative;
  z-index: 1;
  background-image: url(@/assets/images/backgrounds/main-bg.svg);
  background-color: $shade;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  height: 100%;

  &--blue {
    background-color: #f0f8ff;
    background-image: url(@/assets/images/backgrounds/auth/background-pattern.svg);
  }
}
</style>
